import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Stack,
  Avatar,
  InputAdornment,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DaalchiniLogo from "../../assets/dalchini_logo.png";
import Clock from "../../assets/clock.png"
import userIcon from "../../assets/userIcon.png"
import lock from "../../assets/lock.png"
import unlock from "../../assets/unlock.png"
import cancellock from "../../assets/cancel-lock.png"
import refund_redeem from "../../assets/refund_redeem.png"
import OTPInput from "./Otp";
/***********************************
 Responsive Page Wrapper (NO shadow on mobile)
************************************/
import {IMAGE_BASE_URL} from '../../config.js'
const PageWrapper = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      background: {
        xs: "#f4f6f8",
        sm: "linear-gradient(135deg, #eef2ff 0%, #fdf2f8 50%, #ecfeff 100%)",
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: { xs: 0, sm: 2 },
    }}
  >
    <Container maxWidth="sm" disableGutters>
      <Card
        sx={{
            bgcolor:{ xs: "transparent", sm: "rgba(255,255,255,0.8)" },
            mt:{xs: "-100px", sm: 4},
          borderRadius: { xs: 0, sm: 4 },
          p: { xs: 2, sm: 3, md: 4 },
          boxShadow: { xs: "none", sm: "0 20px 60px rgba(0,0,0,0.08)" },
          border: { xs: "none", sm: "1px solid rgba(255,255,255,0.6)" },
          backdropFilter: { sm: "blur(6px)" },
        }}
      >
        {children}
      </Card>
    </Container>
  </Box>
);

/***********************************
 Header
************************************/

const AppHeader = () => (
  <Box sx={{ mb: 2 }} display={"flex"} justifyContent={"start"} justifyItems={"start"} position={"absolute"} top={50} >
  <img
    src={DaalchiniLogo}
    alt="Daalchini Logo"
    style={{ height: 40, display: "block",  }}
  />
  </Box>
);

/***********************************
 Horizontal Cards
************************************/


const ProductCarousel = ({products}) => (
 <>
 { console.log("products",products)}
  <Box
    sx={{
      display: "flex",
      gap: 2,
      overflowX: "auto",
      mt: 2,
      pb: 1,
      scrollSnapType: "x mandatory",
      "&::-webkit-scrollbar": { display: "none" },
    }}
  >
{products?.map((item) => (
  <Card
    key={item.id}
    sx={{
      minWidth: { xs: products?.length > 1 ? "85%" : "100%", sm: 260 },
      flexShrink: 0,
      scrollSnapAlign: "start",
      borderRadius: 3,
      p: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: { xs: "none", sm: "0 6px 18px rgba(0,0,0,0.1)" },
      border: { xs: "1px solid #e5e7eb", sm: "none" },
    }}
  >
    {/* LEFT SIDE (Image + Text) */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      
      {/* Image Box */}
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "#f3f4f6",
          flexShrink: 0,
        }}
      >
        <img
          src={`${IMAGE_BASE_URL}/${item.imageUrl}`}
          alt={item.itemName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      {/* Text */}
      <Box>
        <Typography fontWeight={700} fontSize={15}>
          {item.itemName}
        </Typography>
        <Typography fontSize={12} color="text.secondary">
          {item.itemDescription}
        </Typography>
      </Box>
    </Box>

    {/* RIGHT SIDE ICON */}
    {item.isClaimed ? (
      <CheckCircleIcon sx={{ color: "#22c55e" }} />
    ) : (
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          bgcolor: "#ffe2e2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={lock} alt="lock" style={{ width: "16px" }} />
      </Box>
    )}
  </Card>
))}
  </Box>
  </>
);

/***********************************
 Login Content
************************************/




const LoginContent = ({orderData,mobileNo,handleKeyPress,handleChange,isButtonDisabled,handleAuthenticate,isOTPScreen,handleSubmitOtp}) => {
  console.log("orderData",orderData)
  const [phone, setPhone] = useState("");

  return (
  
    <Box>
      {/* Header */}
      <AppHeader />

      {/* Avatar */}
      <Stack alignItems="center" spacing={1}>
    <img src={userIcon} alt="User Icon" style={{ width: 90, height: 90 }} />

        <Typography fontWeight={700} fontSize={22}>
          Login
        </Typography>

        <Typography fontSize={13} color="text.secondary" textAlign="center">
          Purchased digital cards will be activated after login.
        </Typography>

        <Typography fontSize={12} color="text.secondary">
          Order ID: A123D0076541237F
        </Typography>
      </Stack>

      <ProductCarousel  products={orderData}/>

      {/* Expiry */}
      <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
        <img src={Clock} style={{width:"20px"}}/>
        <Typography fontSize={13}>Expires in 24hr</Typography>
      </Stack>

      <Typography textAlign="center" color="text.secondary" fontSize={13} mt={1}>
        Login
      </Typography>

      {/* Phone */}
 <Box mt={2}>




       {isOTPScreen?<OTPInput handleSubmitOtp={handleSubmitOtp}/>:<>   
       
       <TextField
             fullWidth
         placeholder="Enter mobile number"
         value={mobileNo}
         onKeyPress={handleKeyPress}
         
         onChange={(e) =>{ 
           
        handleChange(e)
 
 
         }}
         inputProps={{ maxLength: 10 }}
        
           sx={{
             mb: 2,
             backgroundColor: "white",
             borderRadius: 1,
             boxShadow: "0 -1px 7px rgb(0 0 0 / 20%)",
             "& .MuiInputBase-input": { paddingLeft: "10px" },
           }}
           InputProps={{
             type: "tel",
             inputMode: "numeric",
             startAdornment: (
               <InputAdornment position="start">
                 <Box
                   component="img"
                   src="https://flagcdn.com/w20/in.png"
                   alt="India"
                   sx={{ width: 24, mr: 1 }}
                 />
                 <Typography variant="body1">+91</Typography>
               </InputAdornment>
             ),
           }}
         /><Button
         onClick={(e)=>{handleAuthenticate(e)}}
          fullWidth
          //disabled={isButtonDisabled}
          sx={{
            mt: 2,
            py: 1.5,
            borderRadius: 3,
            bgcolor: isButtonDisabled ? "#cfcfcf":"#12b981" ,
            color: "white",
            fontWeight: 700,
            fontSize: 16,
            boxShadow: { xs: "none", sm: "0 6px 16px rgba(0,0,0,0.12)" },
            "&:hover": {
              bgcolor:isButtonDisabled ? "#0ea371" : "#cfcfcf",
            },
          }}
        >
          Login To Claim
        </Button></>}

        <Stack direction="row" spacing={1} justifyContent="center" mt={1.5}>
         <img src={refund_redeem} style={{width:"16px"}}/>
          <Typography fontSize={12} color="#16a34a">
            Full Refund If Not Claimed Within Expiry Time
          </Typography>
        </Stack>
      </Box>
 
    </Box>
  );
};

/***********************************
 Root
************************************/

export default function Auth({orderData,handleKeyPress,mobileNo,handleChange,isButtonDisabled,handleAuthenticate,isOTPScreen,handleSubmitOtp}) {
  console.log("orderData",orderData)
  return (
    <PageWrapper>
      <LoginContent  orderData={orderData} mobileNo={mobileNo} handleKeyPress={handleKeyPress}  handleChange={handleChange} isButtonDisabled={isButtonDisabled} handleAuthenticate={handleAuthenticate} isOTPScreen={isOTPScreen} handleSubmitOtp={handleSubmitOtp}/>
    </PageWrapper>
  );
}
